import React, { useState } from "react"
import {
  Row,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Container,
  Col,
  Card,
  CardBody,
} from "reactstrap"
import PropTypes from "prop-types"

import InvoiceOrders from "./index"
import OrderForm from "pages/Orders/OrderForm"
import OrdersFormComponent from "components/OrdersFormComponent"
import InvoiceHistory from "components/Common/InvoiceHistory"

const InvoiceHistoryModel = props => {
  const { isOpen, toggle, value } = props
 
  return (
    <React.Fragment>
      <Row>
        <Offcanvas isOpen={isOpen} direction="end" toggle={toggle}>
          <OffcanvasHeader toggle={toggle}> Invoice History</OffcanvasHeader>
          <OffcanvasBody>
            {/* <OrdersFormComponent /> */}
            <InvoiceHistory isOpen={isOpen} orderObject={value} />
          </OffcanvasBody>
        </Offcanvas>
      </Row>
    </React.Fragment>
  )
}
InvoiceHistoryModel.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  value: PropTypes.object,
  // orderObject: PropTypes.object
}

export default InvoiceHistoryModel
